import { useParams } from 'react-router-dom';
import ListFarms from './components/list-farms';
import ListPonds from './components/list-ponds';

const FarmOverview = () => {
  const params = useParams<{ globalSiteId: string }>();

  if (!params.globalSiteId) return <ListFarms uri={'/production-systems/farm-overview'} />;

  return <ListPonds />;
};

export default FarmOverview;
